<!-- 品名管理-->
<template>
  <div>
        <ctrl-box class="ctrl-box">
            <template>
                <div class="xgroup">
                    <el-link :underline="false" @click="showQuery = !showQuery">
                        <div class="wrap" >
                            <icon-svg icon-class="icon-search" font-size="27px;"/>
                            <span class="txt" >{{msg('搜索')}}</span>      
                        </div>                
                    </el-link>
                    <el-link :underline="false" @click="add()" v-if="hasPermission('simpleProductName:add')">
                        <div class="wrap" >
                            <icon-svg icon-class="icon-tianjia" font-size="27px;"/>
                            <span class="txt">{{msg('添加')}}</span>
                        </div>            
                    </el-link>
                    <el-link :underline="false" @click="edit()" v-if="hasPermission('simpleProductName:edit')">
                        <div class="wrap" >
                            <icon-svg icon-class="icon-bianji" font-size="27px;"/>
                            <span class="txt">{{msg('编辑')}}</span>
                        </div>            
                    </el-link>
                    <el-link :underline="false" @click="editType()" v-if="hasPermission('simpleProductName:add')">
                        <div class="wrap" >
                            <icon-svg icon-class="icon-bianji" font-size="27px;"/>
                            <span class="txt">{{msg('变更类型')}}</span>
                        </div>            
                    </el-link>
                    <el-link :underline="false" @click="updateProductType()" v-if="hasPermission('simpleProductName:updateProductType')">
                        <div class="wrap" >
                            <icon-svg icon-class="icon-putebiaoji" font-size="27px;"/>
                            <span class="txt">{{msg('商品类型')}}</span>
                        </div>            
                    </el-link>
                    <el-link :underline="false" @click="editRename()" v-if="hasPermission('simpleProductName:add')">
                        <div class="wrap" >
                            <icon-svg icon-class="icon-bianji" font-size="27px;"/>
                            <span class="txt">{{msg('替代名')}}</span>
                        </div>            
                    </el-link>
                    <el-link :underline="false" @click="doImport()" v-if="hasPermission('simpleProductName:import')">
                      <div class="wrap" >
                        <icon-svg icon-class="icon-daoru2" font-size="27px;"/>
                        <span class="txt">{{msg('导入')}}</span>
                      </div>
                    </el-link>
                    <el-link :underline="false" @click="doExport()">
                        <div class="wrap" >
                            <icon-svg icon-class="icon-daochu2" font-size="27px;"/>
                            <span class="txt">{{msg('导出列表')}}</span>      
                        </div>         
                    </el-link>
                    <el-link :underline="false" @click="doDelete()" v-if="hasPermission('simpleProductName:delete')">
                        <div class="wrap" >
                            <icon-svg icon-class="icon-shanchu1" font-size="27px;"/>
                            <span class="txt">{{msg('删除')}}</span>      
                        </div>
                    </el-link>
                </div>
            </template>
        </ctrl-box>
 
        <!--查询区域-->
        <transition name="el-zoom-in-top">
            <query-box :query="query" v-show="showQuery" labelWidth="80px">
                <template v-slot:default="scope">
                    <el-form-item :label="msg('品名')">
                        <el-input v-model="scope.query.name" ></el-input>
                    </el-form-item>
                    <el-form-item :label="msg('商品类型')">
                        <el-select v-model="scope.query.productType" :placeholder="msg('请选择')" size="mini" clearable>
                            <el-option
                                v-for="item in dicts.stockExpGoodTypeSim"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item :label="msg('品名')">
                        <el-input type="textarea"  :rows="3" v-model="scope.query.title">
                        </el-input>
                    </el-form-item>
                    <el-form-item :label="msg('替代名')">
                        <el-input v-model="scope.query.rename" ></el-input>
                    </el-form-item>
                    <el-form-item :label="msg('品名类型')" >
                        <el-select v-model="scope.query.open" :placeholder="msg('请选择')" class="query-select">
                             <el-option v-for="d in dicts.isPublics" 
                                :label="d.label" :value="d.value" :key="d.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item :label="msg('创建时间')">
                        <el-date-picker  v-model="scope.query.Date" 
                            type="datetimerange"  
                            :range-separator="msg('至')" 
                            value-format="yyyy-MM-dd HH:mm:ss"
                            end-placeholder=""
                        >
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item :label="msg('匹配时间')">
                        <el-date-picker  v-model="scope.query.UsedDate" 
                            type="datetimerange"  
                            :range-separator="msg('至')" 
                            value-format="yyyy-MM-dd HH:mm:ss"
                            end-placeholder=""
                        >
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item :label="msg('创建ID')">
                      <el-input v-model="scope.query.creater" ></el-input>
                    </el-form-item>
                    <el-row>
                        <el-button type="primary" icon="el-icon-search" @click="list" size="mini">{{msg('搜索')}}</el-button>
                        <el-button icon="el-icon-refresh" size="mini" @click="reset" >{{msg('重置')}}</el-button>
                    </el-row>
                </template>
            </query-box>
        </transition>

        <div class="table-wrap">
            <vxe-grid ref="dataTable" :height="docHeight" 
                export-config
                resizable border="full"
                show-overflow highlight-hover-row
                highlight-current-row highlight-hover-column highlight-current-column
                :data="productNames"
                :columns="columns"
                @cell-click="checkRow"
            ></vxe-grid>

            <pagenator @page-change="handlerPageChange" :query="query" >
            </pagenator>
        </div>

    <el-dialog :title="dgTitle" :visible.sync="dgVisible" :fullscreen="isMinScreen"  
        :close-on-click-modal="false" 
        width="600px" >
        <edit :productName="productNameEdit" ref="dgTitleRef" @close-dg="dgVisibleClose"/>
    </el-dialog>

    <el-dialog title="变更类型" :visible.sync="dgTypeVisible" :fullscreen="isMinScreen"  @opened="openedEditType"
        :close-on-click-modal="false" 
        width="600px" >
        <edit-type ref="dgTypeRef" @close-dg="dgTypeVisibleClose"/>
    </el-dialog>

    <el-dialog
        :title="msg('批量更新商品类型')"
        :visible.sync="updateProductTypeVisiable"
        :close-on-click-modal="false"
        width="400px">
        <el-form ref="updateProductTypeForm" label-width="80px">
            <el-form-item :label="msg('商品类型')">
                <el-select size="mini" v-model="productType" :placeholder="msg('请选择')" clearable>
                    <el-option
                        v-for="item in dicts.stockExpGoodType"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click="updateProductTypeVisiable = false">{{msg('取消')}}</el-button>
            <el-button type="primary" @click="doUpdateProductTypes()">{{msg('确定')}}</el-button>
        </span>
    </el-dialog>

    <el-dialog :title="importDialogTitle" :visible.sync="importDialogVisible" :fullscreen="isMinScreen"
               :close-on-click-modal="false"
               width="600px" >
      <productNameImport ref="importRef" @close-dg="importDialogVisibleClose"/>
    </el-dialog>

    </div>  
</template>
<script>

import Pagenator from "../../components/Pagination.vue";
import CtrlBox from "../../components/CtrlBox.vue";
import QueryBox from "../../components/QueryBox.vue";
import Edit from "./ProductNameEdit.vue";
import EditType from "./ProductNameTypeEdit.vue";
import ProductNameImport from "./ProductNameImport.vue";

export default {
    name: 'simpleProductName',
    components:{
        Pagenator:Pagenator,
        CtrlBox: CtrlBox,
        QueryBox: QueryBox,
        Edit:Edit,
        EditType:EditType,
        ProductNameImport:ProductNameImport
    },
    mounted:function(){
        this.buildColumns();
        this.list();
    },
    data(){
        return {
            query:{
                length: 10,
                start: 0,
                pageIndex:1,
                pageTotal: 0,
                name: null,
                rename: null,
                open: null,
                Date: [],
                UsedDate: [],
                creater: null,
                title: null,
                productType: null,
            },
            showQuery: false,
            curr: null,
            columns: [],
            productNames: [],
            dgTitle: '新增品名',
            dgVisible: false,
            productNameEdit:null,
            importDialogTitle: '批量导入品名',
            importDialogVisible: false,
            dgTypeVisible:false,
            updateProductTypeVisiable: false,
            updateProductTypeIds: null,
            productType: null,
        }
    },
    computed: {
        isMinScreen: {  //是否小屏幕，浏览器
            get() {
            return this.$store.state.isMinScreen;
            }
        },
        docHeight: {  //表格的高度
            get() {
                var height =  this.$store.state.docHeight;
                return height - 220;
            }
        },
    },
    methods: {
        buildColumns(){
            this.columns = [
                {type: 'checkbox', minWidth: 40},
                {field: 'id', title: this.msg('ID'), minWidth: 60, sortable: true},
                {field: 'name', title: this.msg('品名'), minWidth: 120, sortable: true,
                    filters:[{data: null}],
                    filterRender:{name: 'FilterInput'}
                },
                {field: 'productType', title: this.msg('商品类型'), minWidth: 100, sortable: true,
                    slots: {
                        default: ({ row }) => {
                            let type = row.productType;
                            return [
                                <el-tag type={type==6?'warning':'primary'}>{type==6?'KY货':'普货'}</el-tag>
                            ];
                        }
                    },
                    filters:this.dicts.stockExpGoodTypeSim
                },
                {field: 'rename', title: this.msg('替代名'), minWidth: 120, sortable: true,
                    filters:[{data: {vals: [], sVal: ''}}],
                    filterRender:{name: 'FilterContent'}
                },
                {field: 'open', title: this.msg('类型'), minWidth: 120, sortable: true,
                    slots: {
                            default: ({ row }) => {
                                let type = this.dicts.isPublics.find(d => d.value === row.open);
                                return [
                                    <el-tag type={type?type.type:''}>{type?type.label:row.open}</el-tag>
                                ];
                            },
                        },
                    filters:[{data: {vals: [], sVal: ''}}],
                    filterRender:{name: 'FilterContent'}
                },
                {field: 'created', title: this.msg('创建时间'), minWidth:120, sortable: true,
                    filters:[{data: []}],
                    filterRender:{name: 'ElDatePicker', props: {type: 'daterange', rangeSeparator: '至', startPlaceholder: '开始日期', endPlaceholder: '结束日期'}}
                },
                {field: 'usedTime', title: this.msg('匹配时间'), minWidth:120, sortable: true,
                    filters:[{data: []}],
                    filterRender:{name: 'ElDatePicker', props: {type: 'daterange', rangeSeparator: '至', startPlaceholder: '开始日期', endPlaceholder: '结束日期'}}
                },
                {field: 'creater', title: this.msg('创建ID'), minWidth: 120, sortable: true,
                    filters:[{data: {vals: [], sVal: ''}}],
                    filterRender:{name: 'FilterContent'}
                },
            ]
        },
        list(){
            if(this.query.title){
                let cs = this.query.title.split(/\s+/);
        
                let css = [];
                for(let i=0; i<cs.length; i++){
                    if(cs[i]) css.push(cs[i]);
                }
                this.query["names"] = css.join(",");
            }else{
                this.query["names"] = '';
            }
            // if(this.query.usedDate.length>0){
            //     this.query.usedTime = this.$kit.dateFormat(this.query.usedDate[0], 'yyyy-MM-dd HH:mm:ss') + ',' + this.$kit.dateFormat(this.query.usedDate[1], 'yyyy-MM-dd HH:mm:ss');
            // }else{
            //     this.query.usedTime = '';
            // }
            var param = this.$kit.rebuildQuery(this.query);

            this.$axios.post(this.$kit.api.simpleProductName.list, param)
                .then((result) => {
                    if(result.status){
                        this.productNames = result.data.list;
                        this.query.pageTotal = result.data.total;
                    }else{
                        this.$message(result.msg || this.msg('获取失败'));
                    }
                });
        },
        //点击行，选中行
        checkRow({row, $event, column, columnIndex}){
            //如果点击checkbox 则不处理
            // console.log(columnIndex);
            // let className = $event.target.className;
           
            if(columnIndex > 0){  //选择 
                var table =  this.$refs.dataTable;
                table.setCheckboxRow([row], !table.isCheckedByCheckboxRow(row))
            }
        },
        reset(){
            this.$kit.clearQuery(this.query);
        },
        add(){
            this.productNameEdit = {
                id : null,
                name : '',
                rename:'',
                sku:'',
                skus: {"普":[""], "特":[""]}
            },
            this.dgVisible = true;
            this.dgTitle = '新增品名';
        },
        edit(){
            var selectes = this.$refs.dataTable.getCheckboxRecords();
            if(selectes.length==0){
                this.$message(this.msg('请选中一条数据进行操作'));
                return;
            }
            if(selectes.length>1){
                this.$message(this.msg('只能编辑一条数据'));
                return;
            }

            this.productNameEdit = selectes[0];

            if(this.productNameEdit.sku){
                try{

                    let sku = JSON.parse(this.productNameEdit.sku);
                    sku["普"].push("");
                    sku["特"].push("");

                    this.$set(this.productNameEdit, 'skus', sku)
                }catch(err){
                    console.log(err);
                    this.$set(this.productNameEdit, 'skus', {"普":[""], "特":[""]})
                }
            }else{
                this.$set(this.productNameEdit, 'skus', {"普":[""], "特":[""]})
            }

            this.dgVisible = true;
            this.dgTitle = '编辑品名';
        },
        editType(){
            var selectes = this.$refs.dataTable.getCheckboxRecords();
            if(selectes.length==0){
                this.$message(this.msg('请选中一条数据进行操作'));
                return;
            }
            this.dgTypeVisible = true;
        },
        updateProductType(){
            var selectes = this.$refs.dataTable.getCheckboxRecords();
            if(selectes.length==0){
                this.$message(this.msg('请选中一条数据进行操作'));
                return;
            }
            this.updateProductTypeIds = selectes.map(e => e.id).join(",");
            this.productType = null;
            this.updateProductTypeVisiable = true;
        },
        doUpdateProductTypes(){
            if(!this.productType && this.productType != 0){
                this.$message(this.msg('请选择商品类型'));
                return;
            }
            this.$axios.post(this.$kit.api.simpleProductName.updateProductTypes+"?type="+this.productType,this.updateProductTypeIds)
                .then((result) => {
                    if(result.status){
                        this.$message(result.msg || this.msg('更新成功'));
                        this.updateProductTypeVisiable = false;
                        this.list();
                    }else{
                        this.$message(result.msg || this.msg('更新失败'));
                    }
                })
        },
        editRename(){
            var selectes = this.$refs.dataTable.getCheckboxRecords();
            if(selectes.length==0){
                this.$message(this.msg('请选中一条数据进行操作'));
                return;
            }
            if(selectes.length > 50){
                this.$message(this.msg('最多只能编辑50条数据'));
                return;
            }
            this.$prompt(this.msg('请输入替代名'), this.msg('提示'), {
                confirmButtonText: this.msg('确定'),
                cancelButtonText: this.msg('取消'),
            }).then(({ value }) => {
                this.$axios.post(
                    this.$kit.api.simpleProductName.updateRename
                        +"?v="+value,
                        selectes.map(e => e.id).join(",")
                ).then((result) => {
                    if(result.status){
                        this.list();
                        this.$message(result.msg || this.msg('更新成功'));
                    }else{
                        this.$message(this.msg('更新失败'));
                    }
                });
            }).catch(() => {
                this.$message({ 
                    type: 'info',
                    message: this.msg('取消输入')
                });
            });
        },
        openedEditType(){
            var selectes = this.$refs.dataTable.getCheckboxRecords();
            if(selectes.length==0){
                this.$message(this.msg('请选中一条数据进行操作'));
                return;
            }
            this.$nextTick(() => {
                this.$refs.dgTypeRef.init(selectes.map(e => e.id));
            });
        },
        dgTypeVisibleClose(){
            this.dgTypeVisible = false;
            this.list();
        },
        doImport() {
            this.importDialogVisible = true;
        },
        doExport(){
            this.$refs.dataTable.openExport({ isPrint: false })
        },
        dgVisibleClose(){
            this.productNameEdit = {
                id : null,
                name : ''
            },
            this.dgVisible = false;
            this.list();
        },
        importDialogVisibleClose(){
            this.importDialogVisible = false;
            this.list();
        },
        doDelete(){
            var selectes = this.$refs.dataTable.getCheckboxRecords();
            if(selectes.length==0){
                this.$message(this.msg('请选中一条数据进行操作'));
                return;
            }
            if(selectes.length > 50){
                this.$message(this.msg('最多只能删除50条数据'));
                return;
            }
            let params = [];
            selectes.forEach(e => {
                params.push({
                    id:e.id,
                    name:e.name,
                    rename:e.rename
                })
            })
            var _this = this;
            this.$confirm(this.msg('确定要删除选中的数据吗?'), this.msg('提示'), {
                confirmButtonText: this.msg('确定'),
                cancelButtonText: this.msg('取消'),
                type: 'warning'
            }).then(() => {
                _this.$axios.post(_this.$kit.api.simpleProductName.delete,params)
                .then((result) => {
                    if(result > 0){
                        _this.$message(_this.msg('删除成功'));
                        _this.list();
                    }else{
                        _this.$message(_this.msg('只能删除自己创建的品名！'));
                    }
                });
            }).catch((err) => {
                // console.log(err);
            });
        },
        //分页数据发生改变，回调事件：info[0]: 每页显示的数量，info[1]: 起始页
        handlerPageChange(info){
            this.query.length = info[0];
            this.query.start = info[1];
            this.list();
        },
        closeEditDialog(type){  //编辑弹窗关闭后的回调事件
            if(type){
                this.list();
            }
            this.dgVisible = false;
        },
    },
}
</script>

<style lang="scss" scoped>

</style>
